import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Paragraph } from "capitalrx-components-2.0/lib/typography";
import { formatDate } from "capitalrx-utilities";

import { GracePeriodStatus, ParticipationStatus } from "@/App/components";
import { useGetMedicarePrescriptionPaymentPlanFlag, useIsPendingParticipationInMedicarePrescriptionPaymentPlan } from "@/App/hooks";
import { usePlanYear } from "@/App/pages";

import { OptOutForm } from "./OptOutForm";

const TRANSLATION_PATH = "MEDICARE_PRESCRIPTION_PAYMENT_PLAN.participationDetailsPanel";

export const ParticipationDetailsPanel: FC = () => {
  const { t: translate } = useTranslation();
  const planYear = usePlanYear();
  const { flag } = useGetMedicarePrescriptionPaymentPlanFlag(planYear);
  const { isPendingParticipation } = useIsPendingParticipationInMedicarePrescriptionPaymentPlan(planYear);

  const optInDate = useMemo(() => {
    return new Date(flag.effective_date);
  }, [flag]);

  return (
    <Stack spacing="medium-large">
      <Heading>{`${planYear} ` + translate(`${TRANSLATION_PATH}.participationDetails`)}</Heading>
      <Stack spacing="small">
        <Body testId="shelf-participation-status">
          {translate(`${TRANSLATION_PATH}.participationStatus`)} <ParticipationStatus planYear={planYear} />
        </Body>
        <GracePeriodStatus planYear={planYear} />
        {isPendingParticipation && (
          <Body>
            {translate(`${TRANSLATION_PATH}.pendingParticipationDescription`)}
          </Body>
        )}
        {!!optInDate && !isPendingParticipation && (
          <>
            <Body>
              {translate(`${TRANSLATION_PATH}.optedOutOn`)} {formatDate(optInDate, "MM/DD/YYYY")}.
            </Body>
            <Paragraph>
              {translate(`${TRANSLATION_PATH}.referenceId`)} {flag?.id}
            </Paragraph>
          </>
        )}
      </Stack>
      {!isPendingParticipation && <OptOutForm />}
    </Stack>
  );
};
